import { Text, View } from "@react-pdf/renderer";
import React from "react";

export interface DocumentDetailFieldProps
  extends React.HTMLAttributes<HTMLDivElement> {
  label?: string;
  padding?: string;
  depth?: number;
  boldTopBorder?: boolean;
  boldBottomBorder?: boolean;
  isLastChild?: boolean;
  direction?: "row" | "column";
  break?: boolean;
}

const DocumentDetailField = ({
  label,
  padding,
  depth = 1,
  boldBottomBorder,
  isLastChild,
  direction = "row",
  break: isBreak,
  children,
}: DocumentDetailFieldProps) => {
  const labelLines =
    typeof label === "string" ? label.split(/<br\s*\/?>|\n/g) : [];

  return (
    <View
      break={isBreak}
      style={{
        padding,
        width: "100%",
        minHeight: "15mm",
        display: "flex",
        flexDirection: direction,
        alignItems: direction === "row" ? "center" : undefined,
        gap: "4mm",
        borderBottom: isLastChild
          ? undefined
          : boldBottomBorder
            ? "0.5mm solid #6D757F"
            : "0.2mm solid #C6C8CD",
      }}
    >
      {/* Label */}
      {label !== undefined && (
        <View
          style={{
            width: "30mm",
            display: "flex",
            flexDirection: "column", // 줄마다 Text 하나씩 세로 정렬
          }}
        >
          {labelLines.map((line, i) => (
            <Text
              key={i}
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
                fontWeight: depth === 1 ? 700 : 500,
                lineHeight: 1.2,
              }}
            >
              {line}
            </Text>
          ))}
        </View>
      )}

      {/* Content */}
      <View
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </View>
    </View>
  );
};

export default DocumentDetailField;
